import React from 'react';
import AppHeader from './AppHeader';
import AppFooter from './AppFooter';
import AppRouter from '../../pages/appRouter';

export interface ISideLayoutNavItem {
  title: string;
  href: string;
}

export interface ISideLayoutCatalogs {
  title: string;
  list: ISideLayoutNavItem[];
}

export default function AppLayout() {
  return (
    <div>
      <AppHeader />
      <AppRouter />
      <AppFooter />
    </div>
  );
}
